import React from 'react';
import store from 'store';
import u from '../utilities/Utilities';
import AppLayout from '../components-app/AppLayout';
import {Databox,Segment,Step,LoadGraphic,UploadPhoto,EmptyAvatar} from '../components-static/Common';
import {Button} from '../components-static/Input';
import ModuleListMap from '../data/ModuleListMap';
import {Permissions} from './PermissionGroupList';
import {Link} from 'react-router-dom';
import QRCode from 'qrcode.react';
import Measure from 'react-measure';
import "../styles/dashboard.scss";
import "../styles/access-card.scss";
import PropTypes from 'prop-types';
import moment from 'moment';

export default class Dashboard extends React.Component{

    state={
        step: "dashboard",
        action:"No Permission",
        actionLabel:"",
        latestEvents:[],
        name:u.getFullName(),
        avatar:u.getUserAvatar(),
        token:u.getTurnstileToken(),
        tokenTime:u.getTokenTime(),
        loading: false,
        quickActions:[
            {label:"Live View",ref:"turnstiles",image:"/images/dashboard/turnstiles.png",permission:(u.getPermissions("combined").security >= 1)},
            {label:"Permissions",ref:"permissions",image:"/images/dashboard/my-permissions.png",permission:true},
            {label:"My Events",ref:"myEvents",image:"/images/dashboard/my-events.png",permission:(u.getPermissions("history").general >= 1)},
            {label:"Logout",ref:"logout",image:"/images/dashboard/logout.png",permission:true},
        ],
        quickSelected:"",
        name:u.getFullName(),
        dimensions:{
            width:1,
            height:1,
        },
        refreshCode:false,
        liftConfig:{
            floors:{},
            block:"",
            defaultFloor: null,
            defaultFloorWest: null,
            defaultFloorEast: null,
            buildingSetup: {},
        },
        liftSuccessData: null,
    };

    quickAnchor=u.getKey();

    componentDidMount=(e)=>{
        const action = store.get("dashboard-action");
        const actionLabel = store.get("dashboard-action-label");
        store.remove("dashboard-action");
        store.remove("dashboard-action-label");
        this.setState({action:action,actionLabel:actionLabel});
        this.getLatestEvents();
        this.getStaffConfig();

        this.refreshCookies = setInterval(()=>{
            const diff = moment().diff(this.state.tokenTime,"days");
            if(diff > 0){
                this.validateToken();
            }
            else{
                const token = u.getTurnstileToken();
                this.setState({token:token});
            }
        },1000)
    }

    componentWillUnmount=()=>{
        clearInterval(this.refreshCookies);
    }

    getStaffConfig=()=>{
        this.setState({loading:true});
        u.post({
            url:"/api/get-staff",
            data:{
                id:u.getUserID()
            },
            success:(callback)=>{
                const floors = {
                    floors:callback.floors || {},
                    block:callback.block || "",
                    defaultFloor: callback.defaultFloor || null,
                    defaultFloorWest: callback.defaultFloorWest || null,
                    defaultFloorEast: callback.defaultFloorEast || null,
                    buildingSetup: callback.buildingSetup || {},
                }
                this.setState({
                    liftConfig: floors,
                    loading: false
                });
            },
            error:(error)=>{
                this.setState({error:error});
                this.setState({loading:false});
            }
        });
    }

    getLatestEvents=()=>{
        u.post({
            url:"/api/get-latest-events",
            data:{
                tenantID:u.getTenantID(),
                userID:u.getUserID()
            },
            success:(callback)=>{
                this.setState({latestEvents:callback});
            },
            error:(error)=>{
                this.setState({error:error});
            }
        });
    }

    onSetupTask=(e)=>{
        const index = parseInt(e.currentTarget.id);
        const target = this.state.pendingTasks[index];
        const targetMap = ModuleListMap[target.module];
        store.set(targetMap.query,"@id("+target.id+")");
    }

    onQuickAction=(e)=>{
        const index = parseInt(e.currentTarget.id);
        const target=this.state.quickActions[index];

        if(target.ref=="logout"){
            u.logout();
            return 0;
        }

        if(target.ref=="myEvents"){
            store.set("historylist","@staff("+u.getFullName()+")");
            window.open("/history-list","_blank");
            return 0;
        }

        if(target.ref=="turnstiles"){
            window.open("/monitoring","_blank");
            return 0;
        }

        if(target.ref == this.state.quickSelected){
            this.setState({quickSelected:"none"});
        }
        else{
            this.setState({quickSelected:target.ref});
        }
    }

    onCancelQuickAction=()=>{
        this.setState({quickSelected:""});
    }

    onNewProfile=(link)=>{
        store.set("avatarLink",link);
        this.setState({avatar:link,quickSelected:"none"});
    }

    validateToken=()=>{
        this.setState({refreshCode:true});
        u.post({
            url:"/api/validate-token",
            data:{},
            success:(callback)=>{
                //Update cookies
                for(var key in callback){
                    store.set(key,callback[key]);
                }
                store.set("tokenTime",moment().format("YYYY-MM-DD"));
                this.setState({refreshCode:false,token:callback.token,tokenTime:moment().format("YYYY-MM-DD")});
            },
            error:(error)=>{}
        });
    }

    onLiftCallSuccess = (data) => {
        this.setState({
            step: "liftSuccess",
            liftSuccessData: data,
        });
    };

    onLiftSuccessComplete = () => {
        this.setState({
            step: "dashboard",
            liftSuccessData: null,
        });
    };

    render=()=>{
        const width = Math.floor(this.state.dimensions.width);
        const logoWidth = Math.round(width * 0.25);

        return (
            <AppLayout title="Dashboard" requiredPermission="none" url="/dashboard">
                {
                    (this.state.action == "No Permission")
                        ?
                        <div style={{textAlign:"center"}} className="text-negative">You do not have permission to access {this.state.actionLabel} module</div>
                        :
                        ""
                }
                <Step active={this.state.step == "dashboard"}>
                    <Databox active={true} align="center" margin="0">
                    <h2 className="theme-emphasis">Welcome Back, {this.state.name}</h2>

                    <div className="dashboard-qr">
                        <Measure bounds onResize={contentRect => {this.setState({ dimensions: contentRect.bounds })}}>
                            {
                                ({measureRef})=>
                                    (
                                        <div ref={measureRef} className="dashboard-qr-image">
                                            <LoadGraphic active={this.state.refreshCode} text="Refreshing Token..."/>
                                            <QRCode value={this.state.token}
                                                    size={width}
                                                    level="Q"
                                                    imageSettings={{
                                                        src:"/images/cards/soilbuild-qr.png",
                                                        width:logoWidth,
                                                        height:logoWidth,
                                                    }}/>
                                        </div>
                                    )
                            }
                        </Measure>
                    </div>
                    
                    <div className='dashboard-call-lift-button-wrapper'>
                        <div className='dashboard-call-lift-button'>
                            <Button type="large" enabled={!this.state.loading} onClick={()=>{this.setState({step: "callLift"})}}>
                                <img src='/images/access-page/lift.png' className='button-icon'/>Call Lift
                            </Button>
                        </div>
                    </div>

                    <div className="pending-tasks">
                        <h3>My Latest Events</h3>
                        <div style={{width:"750px",maxWidth:"95%",margin:"auto",border:"1px solid #f4f4f4",borderRadius:"5px"}}>
                        {
                            (this.state.latestEvents.length > 0)
                                ?
                                <div>
                                    <div style={{maxHeight:"200px",overflow:"auto"}}>
                                    {
                                        this.state.latestEvents.map(
                                            (item,index)=>{
                                                const isToday = (moment().diff(item.dateTime,"days") == 0);
                                                return (
                                                    <div key={index} className="pending-task-item">
                                                        <div className="pending-task-event">
                                                            <span>{u.capitalize(item.action,true)} </span>
                                                            <span>{(item.targetLink==null) ? item.targetName : <Link to={item.targetLink} id={item.targetLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.targetName}</Link>}</span>
                                                            <span>{(item.targetField==null) ? "" : " (" + item.targetField + ")"}</span>
                                                            <span>{(item.from == null) ? "" : ((item.fromLink == null) ? " from "+item.from : <span> from <Link to={item.fromLink} id={item.fromLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.from}</Link></span>)}</span>
                                                            <span>{(item.to == null) ? "" : ((item.toLink == null) ? " to "+item.to : <span> to <Link to={item.toLink} id={item.toLinkID} onClick={u.setLinkContext} onContextMenu={u.setLinkContext}>{item.to}</Link></span>)}</span>
                                                        </div>
                                                        <div className="pending-task-date">
                                                            {moment(item.dateTime).format((isToday) ? "h:mma" : "DD MMM YY")}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )
                                    }
                                    </div>
                                </div>
                                :
                                <div className="pending-task-empty">No events performed</div>
                        }
                        </div>
                    </div>

                    <div className="quick-actions">
                        <h3>Quick Actions</h3>
                        <div>
                            {
                                this.state.quickActions.map(
                                    (item,index)=>{
                                        return (
                                            <div className="quick-action-item" key={index} id={index+""} onClick={this.onQuickAction}>
                                                <img src={item.image}/>
                                                <div>{item.label}</div>
                                            </div>
                                        )
                                    }
                                )
                            }
                        </div>
                        <div style={{width:"1280px",maxWidth:"98%",margin:"auto"}}>
                            <div className="quick-action-content" id={this.quickAnchor}>
                                <UserPermissions scrollAnchor={this.quickAnchor} active={this.state.quickSelected=="permissions"} onCancel={this.onCancelQuickAction}/>
                            </div>
                        </div>
                    </div>
                </Databox>
                </Step>

                <Step active={this.state.step == "callLift"}>
                    <CallLiftStep 
                        content={this.state.liftConfig} 
                        onSuccess={this.onLiftCallSuccess}
                        onCancel={()=>{this.setState({step:"dashboard"})}}
                    />
                </Step>

                <Step active={this.state.step == "liftSuccess"}>
                    {this.state.liftSuccessData && (
                        <CallLiftSuccessStep 
                            data={this.state.liftSuccessData}
                            onComplete={this.onLiftSuccessComplete}
                        />
                    )}
                </Step>
            </AppLayout>
        )
    }
}

class CallLiftStep extends React.Component {

    state = {
        callLiftDetails: {
            building: "",
            fromFloor: "2",
            toFloor: "",
        },
        buildingOptions: [],
        error: null,
        loading: false,
        floorPad: null,
    };

    componentDidMount = () => {
        const { content } = this.props;

        const isMultiBuilding = content.floors ? Object.keys(content.floors).every((building)=>content.floors[building].length > 0) : false;
        const onlyBuilding = isMultiBuilding ? null : (content.floors ? Object.keys(content.floors).find((building)=>content.floors[building].length > 0) : null);
        const accessibleBuildings = isMultiBuilding ? Object.keys(content.floors) : [onlyBuilding];
        const buildingOptions = Object.keys(content.buildingSetup || {}).map((building) => ({value: building, label: building, enabled: accessibleBuildings.indexOf(building) != -1}));
        const defaultBuilding = isMultiBuilding ? accessibleBuildings[0] : (onlyBuilding || content.block);

        this.setState({
            buildingOptions: buildingOptions,
            callLiftDetails: {
                building: defaultBuilding,
                fromFloor: "2",
                toFloor: this.getDefaultFloor(content, defaultBuilding),
            },
        });
    };

    getDefaultFloor = (content, building) => {
        const floors = content.floors || {};
        const buildingFloors = floors[building] || [];

        const defaultFloor = building == 'East' ? content.defaultFloorEast
            : building == 'West' ? content.defaultFloorWest
            : content.defaultFloor;

        if(defaultFloor && buildingFloors.indexOf(defaultFloor) != -1){
            return defaultFloor + '';
        }

        return buildingFloors.length > 0 ? buildingFloors[0] + '' : '';
    };

    onChangeCallLift = (value, label) => {
        const {callLiftDetails} = this.state;

        callLiftDetails[label] = value;

        if(label == 'building'){
            callLiftDetails.fromFloor = '2';
            callLiftDetails.toFloor = this.getDefaultFloor(this.props.content, value);
        }

        this.setState({callLiftDetails:callLiftDetails, error:null});
    };

    swapFloors = () => {
        const {callLiftDetails} = this.state;
        const temp = callLiftDetails.fromFloor;
        callLiftDetails.fromFloor = callLiftDetails.toFloor;
        callLiftDetails.toFloor = temp;
        this.setState({callLiftDetails:callLiftDetails});
    };

    openFloorPad = (which) => {
        this.setState({floorPad:which});
        document.getElementById('floor-pad-dialog').showModal();
    };

    closeFloorPad = () => {
        document.getElementById('floor-pad-dialog').close();
        this.setState({floorPad:null});
    };

    onFloorPadBackdropClick = (e) => {
        if(e.target.id == 'floor-pad-dialog'){
            this.closeFloorPad();
        }
    };

    selectFloor = (floor) => {
        const {callLiftDetails, floorPad} = this.state;
        callLiftDetails[floorPad] = floor;
        this.setState({callLiftDetails:callLiftDetails, error:null});
        this.closeFloorPad();
    };

    handleConfirm = () => {
        const {callLiftDetails} = this.state;

        if(callLiftDetails.fromFloor == callLiftDetails.toFloor){
            this.setState({error:"From and To floors cannot be the same"});
            return;
        }

        this.setState({error:null});
        document.getElementById('call-lift-dialog').showModal();
    };

    callLift = () => {
        const {callLiftDetails} = this.state;

        u.post({
            url: "/api/call-lift",
            data: {
                fromLevel: callLiftDetails.fromFloor,
                toLevel: callLiftDetails.toFloor,
                buildingID: callLiftDetails.building,
                staffID: u.getUserID(),
            },
            success: (response) => {
                this.setState({ loading: false });
                document.getElementById('call-lift-dialog').close();
                this.props.onSuccess({
                    fromLevel: callLiftDetails.fromFloor,
                    toLevel: callLiftDetails.toFloor,
                    building: callLiftDetails.building,
                    liftID: response.liftName || "Lift",
                });
            },
            error: (err) => {
                document.getElementById('call-lift-dialog').close();
                this.setState({
                    loading: false,
                    error: err && err.message ? err.message : "Failed to call lift. Please try again."
                });
            },
        });
    };

    render = () => {
        const { content } = this.props;
        const { buildingOptions, callLiftDetails, error } = this.state;
        const buildingSetup = content.buildingSetup || {};
        const floors = content.floors || {};

        const accessibleFloors = floors[callLiftDetails.building] ? ['2', ...floors[callLiftDetails.building].map((floor) => floor + '')] : [];
        const numberOfFloors = buildingSetup[callLiftDetails.building] ? buildingSetup[callLiftDetails.building].numberOfFloors : 0;
        const evenFloors = [];
        const oddFloors = [];
        for(let i = numberOfFloors; i >= 2; i--){
            const floor = {value: i + '', enabled: accessibleFloors.indexOf(i + '') != -1};
            (i % 2 === 0 ? evenFloors : oddFloors).push(floor);
        }
        const allFloors = [];
        for(let i = 0; i < Math.max(evenFloors.length, oddFloors.length); i++){
            if(evenFloors[i]) allFloors.push(evenFloors[i]);
            if(oddFloors[i]) allFloors.push(oddFloors[i]);
        }

        return (
            <Segment active={true} align="center" scrollAnchor="callLift">
                <div className="access-card-container">
                    <h2>Call Lift</h2>
                    <div className='access-building-toggle'>
                        {
                            buildingOptions.map((option,index)=>
                                <div
                                    key={index}
                                    className={'access-building-toggle-option' + (callLiftDetails.building == option.value ? ' selected' : '') + (option.enabled ? '' : ' disabled')}
                                    onClick={() => option.enabled && this.onChangeCallLift(option.value,'building')}
                                >
                                    {option.label}
                                </div>
                            )
                        }
                    </div>

                    <div className='floor-select-container'>
                        <div className='floor-select-card from' onClick={() => this.openFloorPad('fromFloor')}>
                            <div className='floor-select-label'><img src='/images/access-page/from.png' className='floor-select-icon'/>From</div>
                            <div className='floor-select-value'>{callLiftDetails.fromFloor}</div>
                        </div>
                        <div className='floor-select-arrow'><img src='/images/access-page/arrow.png' className='floor-select-arrow-icon'/></div>
                        <div className='floor-select-card to' onClick={() => this.openFloorPad('toFloor')}>
                            <div className='floor-select-label'><img src='/images/access-page/to.png' className='floor-select-icon'/>To</div>
                            <div className='floor-select-value'>{callLiftDetails.toFloor}</div>
                        </div>
                    </div>

                    <div className='floor-switch-link'>
                        <a onClick={this.swapFloors}><img src='/images/access-page/switch.png' className='floor-switch-icon'/>Switch</a>
                    </div>

                    <span className='call-lift-error'>{error}</span>
                    <div className='lift-submit-button'>
                        <Button type="large" onClick={this.handleConfirm}>
                            <img src='/images/access-page/lift.png' className='button-icon'/>Call Lift
                        </Button>
                        <Button type="large secondary" onClick={this.props.onCancel}>
                            <img src='/images/access-page/back.png' className='button-icon'/>Back
                        </Button>
                    </div>
                </div>

                <dialog id='call-lift-dialog' className='call-lift-dialog'>
                    <div className='dialog-content'>
                        <h2>Call lift from Level {callLiftDetails.fromFloor} to Level {callLiftDetails.toFloor} in {callLiftDetails.building} building?</h2>
                        <div className='dialog-buttons'>
                            <Button type="large" onClick={() => document.getElementById('call-lift-dialog').close()}>Close</Button>
                            <Button type="large" onClick={this.callLift}>Confirm</Button>
                        </div>
                    </div>
                </dialog>

                <dialog id='floor-pad-dialog' className='floor-pad-dialog' onClick={this.onFloorPadBackdropClick}>
                    <div className='floor-pad-content'>
                        <h2 className='floor-pad-title'>
                            {
                                this.state.floorPad == 'fromFloor'
                                    ?
                                    <span><img src='/images/access-page/from.png' className='floor-select-icon'/>From?</span>
                                    :
                                    <span><img src='/images/access-page/to.png' className='floor-select-icon'/>Where To?</span>
                            }
                        </h2>
                        <div className='floor-pad-grid'>
                            {
                                allFloors.map((floor,index)=>{
                                    const selected = this.state.floorPad && callLiftDetails[this.state.floorPad] == floor.value;
                                    return (
                                        <button
                                            key={index}
                                            className={'floor-pad-button' + (selected ? ' selected' : '') + (floor.enabled ? '' : ' disabled')}
                                            disabled={!floor.enabled}
                                            onClick={() => this.selectFloor(floor.value)}
                                        >
                                            {floor.value}
                                        </button>
                                    )
                                })
                            }
                        </div>
                    </div>
                </dialog>
            </Segment>
        );
    };
}

class CallLiftSuccessStep extends React.Component {
    render = () => {
        const { data, onComplete } = this.props;

        return (
            <Databox active={true} align="center" margin="0">
                <div className="access-card-container">
                    <h2>Lift is Coming</h2>
                    <span>Please proceed to</span>

                    <div className='lift-result'>
                        <span className='lift-id'>{data.liftID}</span>
                    </div>

                    <div className='lift-result'>
                        <div className='lift-result-item'>
                            <span className='lift-result-label'>Building:</span>
                            <span className='lift-result-value'>{data.building}</span>
                        </div>
                        <div className='lift-result-item'>
                            <span className='lift-result-label'>Level:</span>
                            <span className='lift-result-value'>{data.fromLevel} Floor</span>
                        </div>
                    </div>

                    <div className='lift-result'>
                        <span className="destination-label">Destination: </span>
                        <span className='destination-value'>{data.toLevel} Floor</span>
                    </div>

                    <div className='lift-submit-button'>
                        <Button type="large" onClick={onComplete}>OK</Button>
                    </div>
                </div>
            </Databox>
        );
    };
}

class ProfilePic extends React.Component{

    componentDidUpdate=(oldProps,oldState)=>{
        this.refs["photo"].show(this.props.active);
    }

    onToggleForm=()=>{
        this.props.onCancel();
    }

    onComplete=(link)=>{
        this.props.onComplete(link);
    }

    render=()=>{
        return(
            <UploadPhoto scrollAnchor={this.props.scrollAnchor} ref="photo" reference="photo" id={this.id} url={"/api/commit-staff-avatar"} fieldname="avatarLink" onUpload={this.onComplete} onToggleForm={this.onToggleForm} noTitle={true}/>
        )
    }
}

class UserPermissions extends React.Component{

    state={
        content:{
            permissions:u.getAllPermissions()
        }
    };

    render(){
        return (
            <Segment active={this.props.active} align="center" scrollAnchor={this.props.scrollAnchor}>
                <h2>User Permissions</h2>
                <div style={{margin:'20px auto'}}>Permissions can only be edited from the Permission Group page</div>
                <Permissions content={this.state.content} noEdit={true} permission={false} type="slider"/>
                <div className="segment-buttons">
                    <Button type="medium" content={this.state.content} onClick={this.props.onCancel}>Close</Button>
                </div>
            </Segment>
        )
    }
}